// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_7Zx","cls2":"CiterightLanding-cls2_q7a CiterightLanding-cls1_7Zx"};